import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaPlay = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 4V20L20 12L6 4Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMediaPlay.js.map